import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  border: PropTypes.bool,
};

const defaultProps = {
  required: false,
  onChange: null,
  value: '',
  className: '',
  border: false,
};

const TextArea = props => {
  const {
    name,
    id,
    placeholder,
    onChange,
    required,
    value,
    className,
    border,
    onBlur,
  } = props;

  return (
    <textarea
      {...props}
      className={clsx(
        `appearance-none block w-full py-2 px-2 text-gray-800 rounded h-16 overflow-auto border-none shadow-input focus:shadow-input-focus`,
        className,
      )}
      border={border}
      name={name}
      id={id}
      placeholder={placeholder}
      onChange={onChange ? e => onChange(e) : null}
      required={required}
      value={value || null}
      onBlur={onBlur}
    />
  );
};

TextArea.propTypes = propTypes;
TextArea.defaultProps = defaultProps;

export default TextArea;
